import React from "react";
import { TextField } from "@mui/material";
import Label from "./LabelF";

const Like = (props) => {
  const {
    id,
    id_a,
    label,
    filtrosAAplicar,
    setFiltrosAAplicar,
    error,
    setError,
  } = props;

  const handleInput = (e) => {
    const { value } = e.target;
    setFiltrosAAplicar((prevState) => {
      const nuevosFiltros = { ...prevState, [id_a]: value };
    
      if (props.clave_envio) {
        nuevosFiltros[props.clave_envio] = value;
      }
    
      return nuevosFiltros;
    });
    setError((e) => {
      return { ...e, [id_a]: false };
    });
  };

//  const classes = useStyle();

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      // Ejecutar la función proporcionada por el componente envuelto (WrappedComponent)
      props.handleSubmit(event);
    }
  };

  return (
    <div className="likeComponente">
      <Label
        label={props.nombre}
        opcionales_null={props.opcionales_null}
        permite_null={props.permite_null}
      />
      <TextField
        id={id}
        type="text"
        placeholder={props.placeholder}
        style={{ width: "100%" }}
        onChange={handleInput}
        onKeyDown={handleKeyDown}
        defaultValue={props.default}
        label={label}
        value={filtrosAAplicar[id_a] ? filtrosAAplicar[id_a] : ""}
        error={error[id_a]}
        // className={classes.likeComponent}
        variant="standard"
      />
    </div>
  );
};
export default Like;
